import { ref } from 'vue';

export function useMobileDialog() {
    const menuVisible = ref(false);

    function toggleMenu() {
        if (!import.meta.client) {
            return;
        }

        const isMobile = window.innerWidth < 768;
        if (isMobile) {
            menuVisible.value = !menuVisible.value;
        }
    }

    return { menuVisible, toggleMenu };
}
